import { api } from '@/service/http';
import { arkiStore } from '@/views/arki/services/arki-store';

export const appName = 'arki';
export const baseUrl = 'infoenergo';
export const monthsList = [
    { id: 1, name: 'Январь', shortName: 'Я' },
    { id: 2, name: 'Февраль', shortName: 'Ф' },
    { id: 3, name: 'Март', shortName: 'Мр' },
    { id: 4, name: 'Апрель', shortName: 'Ап' },
    { id: 5, name: 'Май', shortName: 'Мй' },
    { id: 6, name: 'Июнь', shortName: 'Ин' },
    { id: 7, name: 'Июль', shortName: 'Ил' },
    { id: 8, name: 'Август', shortName: 'Ав' },
    { id: 9, name: 'Сентябрь', shortName: 'С' },
    { id: 10, name: 'Октябрь', shortName: 'О' },
    { id: 11, name: 'Ноябрь', shortName: 'Н' },
    { id: 12, name: 'Декабрь', shortName: 'Д' }
];

export const homeButtons = [{
    name: 'Реест заявок',
    url: 'requests',
}, {
    name: 'Настройки',
    url: 'work-setting',
}];


function createErrorResponse(error, uuid) {
    return {
        result: false,
        error: error.message || error.error || error,
        uuid,
    };
}

export const getData = async (url, uuid, args = null, dictionary = null) => {
    if (dictionary && arkiStore.dictionary[dictionary])
        return arkiStore.dictionary[dictionary];

    try {
        const result = await api(`${appName}.${url}/get`, args);

        if (dictionary)
            arkiStore.dictionary[dictionary] = result.data;

        return result.data;
    } catch (error) {
        return createErrorResponse(error, uuid);
    }
};
